import { Alert } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { CardContent, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useCheckLimitReached } from '../../hooks/use-check-limit-reached';
import { AddMemberForm } from '../add-member-form';
import * as Styled from './styles';
import * as SX from './sx';
import type { InviteMemberProps as Props } from './types';

export const InviteMember = memo(({ className, onCloseForm }: Props) => {
  const { hasLimitReached, seat } = useCheckLimitReached();

  return (
    <Styled.Wrapper
      className={classnames('InviteMember', className)}
      sx={SX.root}
    >
      <CardContent padding="extra">
        <Stack gap={2}>
          <Stack>
            <Typography variant="body2" fontWeight={700} color="grey.700">
              Invite Team Members
            </Typography>
            <Typography variant="body5" fontWeight={400} color="grey.500">
              When you invite members to join AI ark, they will receive an
              invitation email.
            </Typography>
          </Stack>
          <AddMemberForm onClose={onCloseForm} />
          {hasLimitReached && (
            <Alert
              variant="standard"
              severity="info"
              message={`Limit Reached: ${seat} Free seats per account.`}
              title="Limit Reached"
              hideHeader
            >
              This is an info Alert.
            </Alert>
          )}
        </Stack>
      </CardContent>
    </Styled.Wrapper>
  );
});

InviteMember.displayName = 'InviteMember';
